import { css } from '@linaria/atomic'

export const extendedStyles = css`
    font-size: 24px;
    line-height: 24px;
`

export const rootStyles = css`
    display: flex;
    background: #111;
    flex: 1;
    justify-content: center;
    align-items: center;
    transform: translate3d(0, 0, 0);
    overflow: hidden;
    cursor: pointer;
    font-size: 0.8125rem;
`
